export default __webpack_public_path__ + "static/media/Clip.6a3815e6.svg";